import {IntermediatePart} from "../../intermediatePart";

export default class TowelBar extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'towel_bar';
    this.partName = 'Towel Bar';
    this.translateId = "visualizer.bathroom.accessories.towel_bar";
    this.canBeDisabled = true;
    // if (isChild) {
    //   createParentPositions(this);
    // }
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Accessories.TowelBar;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
  }
}
